module.exports = __webpack_public_path__ + "static/media/underthegun.f5e1a397.png";